module.exports = __webpack_public_path__ + "static/media/logoMealkit.d54da333.svg";